<template src="./template.html"></template>

<script>
export default {
  name: "MainDialog",
  data() {
    return {}
  },
  methods: {
    Close() {
      this.$store.commit("SetDialog", { status: false, content: "" })
    }
  }
}
</script>